import React, { useState } from 'react'
import styles from './Modal.module.css'
import ColorOption from '../Options/ColorOption/ColorOption'
import ImageOption from '../Options/ImageOption/ImageOption'
import TextOption from '../Options/TextOption/TextOption'
import ImageSelection from '../Options/ImageOption/ImageSelection'


const Modal = ({ isOpen, setIsOpen, options, setOptions }) => {

    
    const [formStep, setFormStep] = useState(0)
   

    const handleSelection =(e) => {
      setOptions({...options, [e.target.name]: e.target.value})
    }

    const handleChange = (e) => {
        
        if(e.target.checked) {
            setOptions({...options, mainColors:[...options.mainColors, e.target.value]})
            
        }
        else {
            const newState = {...options, mainColors: options.mainColors.filter(prev => prev !== e.target.value)};
            setOptions(newState)

        }
        
    };

    console.log(options)

    // const found = color2.some(r=> color1.includes(r))

    const handleSubmit =(e) => {
      e.preventDefault()
      console.log(options)
    }
  

    const cancel =()=> {
        document.querySelectorAll('input[type=checkbox]').forEach( el => el.checked = false );
        document.querySelectorAll('input[type=radio]').forEach( el => el.checked = false );
        setFormStep(0)
        setIsOpen((prevState) => !prevState)
        
        
    }

    const showResult =() => {
        document.querySelectorAll('input[type=checkbox]').forEach( el => el.checked = false );
        document.querySelectorAll('input[type=radio]').forEach( el => el.checked = false );
        setFormStep(0)
        setIsOpen((prevState) => !prevState)
    }

    const previous =() => {
        setFormStep((prevState) => prevState - 1)
    }
    const next =() => {
        setFormStep((prevState) => prevState + 1)
    }

    return (
        <div className={isOpen? `${styles.modal}` : `${styles.hide}`}>
            <div  className={styles.form}>
                <form onSubmit={handleSubmit}>
                    <p>Step {formStep + 1} of 7</p>
                {formStep === 0 && (
                    <section>
                        <h3>What is the location of this Species? </h3>
                        <input type="text" name="location" onChange={handleSelection} placeholder="E.g Weppa Farms, Nigeria" className={styles.location}/>
                        <h3>What is the Size of the Species? : {options.size}</h3>
                        <div className={styles.buttons}>
                            <ImageOption name="size" src="https://i.postimg.cc/vDynSKdX/sparrow-Size.png" handleSelection={handleSelection} value="Sparrow-Size" />
                            <ImageSelection name="size" handleSelection={handleSelection} value="Sparrow-Thrush Size" />
                            <ImageOption name="size" src="https://i.postimg.cc/1f5qyNXq/Thrush-Size.png" handleSelection={handleSelection} value="Thrush-Size" />
                            <ImageSelection name="size" handleSelection={handleSelection} value="Thrush-Crow Size" />
                            <ImageOption name="size" src="https://i.postimg.cc/YjxFcxr7/crowSize.png" handleSelection={handleSelection} value="Crow-Size" />
                            <ImageSelection name="size" handleSelection={handleSelection} value="Crow-Turkey Size" />
                            <ImageOption name="size" src="https://i.postimg.cc/YLtmGvxT/turkey-Size.png" handleSelection={handleSelection} value="Turkey-Size" />
                        </div>
                    </section>
                )}
                      
                {formStep === 1  && (
                    <section>
                     <h3>Main Colors (Select 3): {options.mainColors.join(', ')}</h3>
                    <div className={styles.buttons}>
                        <ColorOption type="checkbox" name="mainColors" value="black" id="black" htmlFor="black" handleChange={handleChange} selectedColor="black" disabled={options.mainColors.length > 2 ? true : null } />
                        <ColorOption type="checkbox" name="mainColors" value="brown" id="brown" htmlFor="brown" handleChange={handleChange} selectedColor="brown" disabled={options.mainColors.length > 2 ? true : null } />
                        <ColorOption type="checkbox" name="mainColors" value="red" id="red" htmlFor="red" handleChange={handleChange} selectedColor="red" disabled={options.mainColors.length > 2 ? true : null } />
                        <ColorOption type="checkbox" name="mainColors" value="gray" id="gray" htmlFor="gray" handleChange={handleChange} selectedColor="gray" disabled={options.mainColors.length > 2 ? true : null } />
                        <ColorOption type="checkbox" name="mainColors" value="blue" id="blue" htmlFor="blue" handleChange={handleChange} selectedColor="blue" disabled={options.mainColors.length > 2 ? true : null } />
                        <ColorOption type="checkbox" name="mainColors" value="cyan" id="cyan" htmlFor="cyan" handleChange={handleChange} selectedColor="cyan" disabled={options.mainColors.length > 2 ? true : null } />
                        <ColorOption type="checkbox" name="mainColors" value="purple" id="purple" htmlFor="purple" handleChange={handleChange} selectedColor="purple" disabled={options.mainColors.length > 2 ? true : null } />
                        <ColorOption type="checkbox" name="mainColors" value="yellow" id="yellow" htmlFor="yellow" handleChange={handleChange} selectedColor="yellow" disabled={options.mainColors.length > 2 ? true : null } />
                        <ColorOption type="checkbox" name="mainColors" value="green" id="green" htmlFor="green" handleChange={handleChange} selectedColor="green" disabled={options.mainColors.length > 2 ? true : null } />
                        <ColorOption type="checkbox" name="mainColors" value="white" id="white" htmlFor="white" handleChange={handleChange} selectedColor="white" disabled={options.mainColors.length > 2 ? true : null } />
                    </div>
                </section>
                )}

                
                {formStep === 2  && (
                    <section>
                     <h3>Head Color (Select 1): {options.headColor}</h3>
                    <div className={styles.buttons}>
                        <ColorOption type="radio" name="headColor" value="black" id="black" htmlFor="black" handleSelection={handleSelection} selectedColor="black" />
                        <ColorOption type="radio" name="headColor" value="brown" id="brown" htmlFor="brown" handleSelection={handleSelection} selectedColor="brown" />
                        <ColorOption type="radio" name="headColor" value="red" id="red" htmlFor="red" handleSelection={handleSelection} selectedColor="red" />
                        <ColorOption type="radio" name="headColor" value="gray" id="gray" htmlFor="gray" handleSelection={handleSelection} selectedColor="gray" />
                        <ColorOption type="radio" name="headColor" value="blue" id="blue" htmlFor="blue" handleSelection={handleSelection} selectedColor="blue" />
                        <ColorOption type="radio" name="headColor" value="cyan" id="cyan" htmlFor="cyan" handleSelection={handleSelection} selectedColor="cyan" />
                        <ColorOption type="radio" name="headColor" value="purple" id="purple" htmlFor="purple" handleSelection={handleSelection} selectedColor="purple" />
                        <ColorOption type="radio" name="headColor" value="yellow" id="yellow" htmlFor="yellow" handleSelection={handleSelection} selectedColor="yellow" />
                        <ColorOption type="radio" name="headColor" value="green" id="green" htmlFor="green" handleSelection={handleSelection} selectedColor="green" />
                        <ColorOption type="radio" name="headColor" value="white" id="white" htmlFor="white" handleSelection={handleSelection} selectedColor="white" />
                    </div>
                </section>
                )}


                {formStep === 3  && (
                    <section>
                     <h3>Upper Color (Select 1): {options.upperColor}</h3>
                    <div className={styles.buttons}>
                        <ColorOption type="radio" name="upperColor" value="black" id="black" htmlFor="black" handleSelection={handleSelection} selectedColor="black" />
                        <ColorOption type="radio" name="upperColor" value="brown" id="brown" htmlFor="brown" handleSelection={handleSelection} selectedColor="brown" />
                        <ColorOption type="radio" name="upperColor" value="red" id="red" htmlFor="red" handleSelection={handleSelection} selectedColor="red" />
                        <ColorOption type="radio" name="upperColor" value="gray" id="gray" htmlFor="gray" handleSelection={handleSelection} selectedColor="gray" />
                        <ColorOption type="radio" name="upperColor" value="blue" id="blue" htmlFor="blue" handleSelection={handleSelection} selectedColor="blue" />
                        <ColorOption type="radio" name="upperColor" value="cyan" id="cyan" htmlFor="cyan" handleSelection={handleSelection} selectedColor="cyan" />
                        <ColorOption type="radio" name="upperColor" value="purple" id="purple" htmlFor="purple" handleSelection={handleSelection} selectedColor="purple" />
                        <ColorOption type="radio" name="upperColor" value="yellow" id="yellow" htmlFor="yellow" handleSelection={handleSelection} selectedColor="yellow" />
                        <ColorOption type="radio" name="upperColor" value="green" id="green" htmlFor="green" handleSelection={handleSelection} selectedColor="green" />
                        <ColorOption type="radio" name="upperColor" value="white" id="white" htmlFor="white" handleSelection={handleSelection} selectedColor="white" />
                    </div>
                </section>
                )}

                {formStep === 4  && (
                    <section>
                     <h3>Belly Color: {options.bellyColor}</h3>
                    <div className={styles.buttons}>
                        <ColorOption type="radio" name="bellyColor" value="black" id="black" htmlFor="black" handleSelection={handleSelection} selectedColor="black" />
                        <ColorOption type="radio" name="bellyColor" value="brown" id="brown" htmlFor="brown" handleSelection={handleSelection} selectedColor="brown" />
                        <ColorOption type="radio" name="bellyColor" value="red" id="red" htmlFor="red" handleSelection={handleSelection} selectedColor="red" />
                        <ColorOption type="radio" name="bellyColor" value="gray" id="gray" htmlFor="gray" handleSelection={handleSelection} selectedColor="gray" />
                        <ColorOption type="radio" name="bellyColor" value="blue" id="blue" htmlFor="blue" handleSelection={handleSelection} selectedColor="blue" />
                        <ColorOption type="radio" name="bellyColor" value="cyan" id="cyan" htmlFor="cyan" handleSelection={handleSelection} selectedColor="cyan" />
                        <ColorOption type="radio" name="bellyColor" value="purple" id="purple" htmlFor="purple" handleSelection={handleSelection} selectedColor="purple" />
                        <ColorOption type="radio" name="bellyColor" value="yellow" id="yellow" htmlFor="yellow" handleSelection={handleSelection} selectedColor="yellow" />
                        <ColorOption type="radio" name="bellyColor" value="green" id="green" htmlFor="green" handleSelection={handleSelection} selectedColor="green" />
                        <ColorOption type="radio" name="bellyColor" value="white" id="white" htmlFor="white" handleSelection={handleSelection} selectedColor="white" />
                    </div>
                </section>
                )}


                {formStep === 5 && (
                    <section>
                        <h3>Bill Shape : {options.billShape}</h3>
                        <div className={styles.textOptionbuttons}></div>
                        <TextOption name="billShape" handleSelection={handleSelection} value="cornical" />
                        <TextOption name="billShape" handleSelection={handleSelection} value="forked" />
                        <TextOption name="billShape" handleSelection={handleSelection} value="Long & Spear-shaped" />
                        <TextOption name="billShape" handleSelection={handleSelection} value="Short, thin, pointy" />
                        <TextOption name="billShape" handleSelection={handleSelection} value="Short, tiny, pointy" />
                        <TextOption name="billShape" handleSelection={handleSelection} value="Thick, large decurved" />
                        <TextOption name="billShape" handleSelection={handleSelection} value="Thin, long and decurved" />
                    </section>
                )}

                {formStep === 6 && (
                    <section>
                        <h3>Tail Shape : {options.tailShape}</h3>
                        <div className={styles.textOptionbuttons}></div>
                        <TextOption name="tailShape" handleSelection={handleSelection} value="Cleft" />
                        <TextOption name="tailShape" handleSelection={handleSelection} value="Double-Rounded" />
                        <TextOption name="tailShape" handleSelection={handleSelection} value="Forked" />
                        <TextOption name="tailShape" handleSelection={handleSelection} value="Graduated" />
                        <TextOption name="tailShape" handleSelection={handleSelection} value="Narrow" />
                        <TextOption name="tailShape" handleSelection={handleSelection} value="Ribbon-like" />
                        <TextOption name="tailShape" handleSelection={handleSelection} value="Ribbon-like; Rounded" />
                        <TextOption name="tailShape" handleSelection={handleSelection} value="Rounded" />
                        <TextOption name="tailShape" handleSelection={handleSelection} value="Short" />
                        <TextOption name="tailShape" handleSelection={handleSelection} value="Wedged" />
                    </section>
                )}

                
                    
                </form>

                <div className={styles.navButtons}>
                    <button onClick={previous} disabled={formStep === 0 && true } ><i className="fas fa-arrow-left"></i></button>
                    <button onClick={next} disabled={formStep === 6 && true }><i className="fas fa-arrow-right"></i></button>
                    <button onClick={cancel}><i className="fas fa-times"></i></button>
                    <button onClick={showResult} className={styles.submitBtn} type="submit" disabled={formStep < 4 ? true : false}>Show results</button>
                </div>
            </div>
            
        </div>
    )
}

export default Modal
